module.exports = __webpack_public_path__ + "img/Transit_acc_1.f2070125.jpg";